import React from "react";
import { ToastContainer, toast } from 'react-toastify';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { adminRegisterVendor } from "../services/Api";
import { useLocation, useNavigate } from "react-router-dom";

export default function VendorForm() {
    const location = useLocation();
    const navigate = useNavigate();
    const vendorDetails = location?.state?.user || null;
    console.log(vendorDetails)
    const initialValues = {
        account_type: 'vendor',
        vendor_id: vendorDetails?._id || "",
        companyName: "",
        firstName: "",
        lastName: "",
        email: "",
        city: "",
        address: "",
        businessRegistration: "",
        phoneNumber: vendorDetails?.phoneNumber || "",
        // vendor_bank_details: {
        //     account_number: "",
        //     account_ifsc: "",
        //     account_holder_name: "",
        //     branch_name: "",
        // },
        aadhaar_number: "",
        // upi_id: "",
    };

    const validationSchema = Yup.object({
        companyName: Yup.string().required("Company Name is required"),
        firstName: Yup.string().required("First Name is required"),
        // lastName: Yup.string().required("Last Name is required"),
        email: Yup.string().email("Invalid email").required("Email is required"),
        // city: Yup.string().required("City is required"),
        // address: Yup.string().required("Address is required"),
        // businessRegistration: Yup.string().required("Business Registration is required"),
        phoneNumber: Yup.string()
            .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
            .required("Phone number is required"),
        // vendor_bank_details: Yup.object().shape({
        //     account_number: Yup.string()
        //         .matches(/^\d{9,18}$/, "Invalid Account Number")
        //         .required("Account Number is required"),
        //     account_ifsc: Yup.string()
        //         .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code")
        //         .required("IFSC code is required"),
        //     account_holder_name: Yup.string()
        //         .required("Account Holder Name is required"),
        //     branch_name: Yup.string()
        //         .required("Branch Name is required"),
        // }),
        aadhaar_number: Yup.string()
            .test("aadhaar-format", "Aadhaar must be 12 digits", (value = "") =>
                /^\d{12}$/.test(value.replace(/\s/g, ""))
            )
            .required("Aadhaar number is required"),
        // upi_id: Yup.string()
        //     .required("UPI ID is required")
        //     .matches(/^[\w.-]{2,256}@[a-zA-Z]{2,64}$/, "Invalid UPI ID"),
    });

    const handleSubmit = (values) => {
        console.log("Form submitted:", values);

        adminRegisterVendor(values)
            .then((res) => {
                toast(res.data.message)
                setTimeout(() => {
                    navigate(-1)
                }, 2000)
            })
            .catch((error) => {
                console.error("Error registering vendor:", error);
                toast(error.response.data.message);
            });
    };

    return (
        <>
            < ToastContainer />
            <div className=" p-6 mt-10 bg-white shadow-lg rounded-lg mx-5 sm:mx-10 lg:mx-20">
                <button className="flex items-center w-fit bg-[#E53935] px-2 py-1 rounded-md active:scale-95 duration-500 my-5" onClick={() => navigate(-1)}>
                    <svg width="20" height="20" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5516 21.3393H30.2057C30.6543 21.3393 31.0304 21.1875 31.3339 20.8841C31.6373 20.5806 31.7891 20.2045 31.7891 19.7559C31.7891 19.3073 31.6373 18.9313 31.3339 18.6278C31.0304 18.3243 30.6543 18.1726 30.2057 18.1726H12.5516L17.0641 13.6601C17.3807 13.3434 17.5325 12.974 17.5193 12.5518C17.5061 12.1295 17.3543 11.7601 17.0641 11.4434C16.7474 11.1268 16.3714 10.9618 15.9359 10.9486C15.5005 10.9354 15.1245 11.0872 14.8078 11.4038L7.56406 18.6476C7.40573 18.8059 7.29358 18.9775 7.2276 19.1622C7.16163 19.3469 7.12865 19.5448 7.12865 19.7559C7.12865 19.967 7.16163 20.165 7.2276 20.3497C7.29358 20.5344 7.40573 20.7059 7.56406 20.8643L14.8078 28.108C15.1245 28.4247 15.5005 28.5764 15.9359 28.5632C16.3714 28.55 16.7474 28.3851 17.0641 28.0684C17.3543 27.7518 17.5061 27.3823 17.5193 26.9601C17.5325 26.5379 17.3807 26.1684 17.0641 25.8518L12.5516 21.3393Z" fill="white" />
                    </svg>
                    <button className="">
                        <span className=" text-white ms-1">Back</span>
                    </button>
                </button>
                <p className="text-2xl  font-bold mb-6 text-center">Vendor Registration Form</p>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ values, setFieldValue }) => (
                        <Form className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {/* First Name */}
                            <div>
                                <label className="block mb-1 font-medium">First Name</label>
                                <Field
                                    name="firstName"
                                    className="w-full p-2 border rounded-md"
                                    placeholder="Enter first name"
                                />
                                <ErrorMessage name="firstName" component="div" className="text-red-500 text-xs" />
                            </div>

                            {/* Last Name */}
                            <div>
                                <label className="block mb-1 font-medium">Last Name</label>
                                <Field
                                    name="lastName"
                                    className="w-full p-2 border rounded-md"
                                    placeholder="Enter last name"
                                />
                                <ErrorMessage name="lastName" component="div" className="text-red-500 text-xs" />
                            </div>

                            {/* Email */}
                            <div>
                                <label className="block mb-1 font-medium">Email</label>
                                <Field
                                    type="email"
                                    name="email"
                                    className="w-full p-2 border rounded-md"
                                    placeholder="Enter email"
                                />
                                <ErrorMessage name="email" component="div" className="text-red-500 text-xs" />
                            </div>

                            {/* City */}
                            <div>
                                <label className="block mb-1 font-medium">City</label>
                                <Field
                                    name="city"
                                    className="w-full p-2 border rounded-md"
                                    placeholder="Enter city"
                                />
                                <ErrorMessage name="city" component="div" className="text-red-500 text-xs" />
                            </div>

                            {/* Address */}
                            <div>
                                <label className="block mb-1 font-medium">Address</label>
                                <Field
                                    name="address"
                                    className="w-full p-2 border rounded-md"
                                    placeholder="Enter address"
                                />
                                <ErrorMessage name="address" component="div" className="text-red-500 text-xs" />
                            </div>

                            {/* Company Name */}
                            <div>
                                <label className="block mb-1 font-medium">Company Name</label>
                                <Field
                                    name="companyName"
                                    className="w-full p-2 border rounded-md"
                                    placeholder="Enter company name"
                                />
                                <ErrorMessage name="companyName" component="div" className="text-red-500 text-xs" />
                            </div>

                            {/* Business Registration */}
                            <div>
                                <label className="block mb-1 font-medium">Business Registration</label>
                                <Field
                                    name="businessRegistration"
                                    className="w-full p-2 border rounded-md"
                                    placeholder="Enter registration number"
                                />
                                <ErrorMessage name="businessRegistration" component="div" className="text-red-500 text-xs" />
                            </div>

                            {/* Phone Number */}
                            <div>
                                <label className="block mb-1 font-medium">Phone Number</label>
                                <Field
                                    disabled
                                    name="phoneNumber"
                                    className="w-full p-2 border rounded-md"
                                    placeholder="Enter phone number"
                                />
                                <ErrorMessage name="phoneNumber" component="div" className="text-red-500 text-xs" />
                            </div>
                            {/* <div>
                                <label className="block mb-1 font-medium">Account Number</label>
                                <Field
                                    name="vendor_bank_details.account_number"
                                    className="w-full p-2 border rounded-md"
                                    placeholder="Enter account number"
                                />
                                <ErrorMessage
                                    name="vendor_bank_details.account_number"
                                    component="div"
                                    className="text-red-500 text-xs"
                                />
                            </div>

                            <div>
                                <label className="block mb-1 font-medium">IFSC Code</label>
                                <Field name="vendor_bank_details.account_ifsc">
                                    {({ field, form }) => (
                                        <input
                                            {...field}
                                            type="text"
                                            placeholder="Enter IFSC"
                                            className="w-full p-2 border rounded-md"
                                            onChange={(e) => {
                                                form.setFieldValue(field.name, e.target.value.toUpperCase());
                                            }}
                                        />
                                    )}
                                </Field>
                                <ErrorMessage
                                    name="vendor_bank_details.account_ifsc"
                                    component="div"
                                    className="text-red-500 text-xs"
                                />
                            </div>

                            <div>
                                <label className="block mb-1 font-medium">Account Holder Name</label>
                                <Field
                                    name="vendor_bank_details.account_holder_name"
                                    className="w-full p-2 border rounded-md"
                                    placeholder="Enter holder name"
                                />
                                <ErrorMessage
                                    name="vendor_bank_details.account_holder_name"
                                    component="div"
                                    className="text-red-500 text-xs"
                                />
                            </div>

                            <div>
                                <label className="block mb-1 font-medium">Branch Name</label>
                                <Field
                                    name="vendor_bank_details.branch_name"
                                    className="w-full p-2 border rounded-md"
                                    placeholder="Enter branch name"
                                />
                                <ErrorMessage
                                    name="vendor_bank_details.branch_name"
                                    component="div"
                                    className="text-red-500 text-xs"
                                />
                            </div>

                            <div>
                                <label className="block mb-1 font-medium">UPI ID</label>
                                <Field
                                    name="upi_id"
                                    className="w-full p-2 border rounded-md"
                                    placeholder="example@upi"
                                />
                                <ErrorMessage name="upi_id" component="div" className="text-red-500 text-xs" />
                            </div> */}

                            {/* Aadhaar Number */}
                            <div>
                                <label className="block mb-1 font-medium">Aadhaar Number</label>
                                <Field
                                    name="aadhaar_number"
                                    className="w-full p-2 border rounded-md"
                                    placeholder="XXXX XXXX XXXX"
                                    onChange={(e) => {
                                        let value = e.target.value.replace(/\D/g, "");
                                        value = value.slice(0, 12);
                                        value = value.replace(/(\d{4})(?=\d)/g, "$1 ");
                                        setFieldValue("aadhaar_number", value);
                                    }}
                                />
                                <ErrorMessage name="aadhaar_number" component="div" className="text-red-500 text-xs" />
                            </div>

                            {/* Submit Button */}
                            <div className=" col-span-2 flex justify-end">
                                <button
                                    type="submit"
                                    className="bg-[#E53935] hover:bg-white border-2 border-[#E53935] hover:text-[#E53935] active:scale-95 duration-500 text-white px-5 py-2 font-semibold rounded-md"
                                >
                                    Submit
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    );
}
